export const CHECKLISTS_UI_VERSION_KEY = 'checklists-ui-version'
